
'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {TimesCitedService} from "../timesCited/timesCited.service";
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';


@Injectable()
export class CitationTrailsFullviewLinkService {
    constructor(private timesCitedService: TimesCitedService,
                private configurationUtil: ConfigurationUtil) {
    }

    private showCitationTrialForSuprima:boolean;

    public hasCitedby(record:PrimoResponse.IExtendedDoc){
        return  record && record.extras && record.extras.citationTrails && record.extras.citationTrails.citedby && record.extras.citationTrails.citedby.length > 0;
    }

    public hasCiting(record:PrimoResponse.IExtendedDoc){
        return record && record.extras && record.extras.citationTrails && record.extras.citationTrails.citing && record.extras.citationTrails.citing.length > 0;
    }

    public isShowCitationTrialForSuprima(){
       return this.showCitationTrialForSuprima;
    }

    public setShowCitationTrialForSuprima(showCitationTrialForSuprimaArg:boolean){
       this.showCitationTrialForSuprima = showCitationTrialForSuprimaArg;
    }

    public shouldDisplayTimesCited(){
        if(this.configurationUtil.isSuprima()){
            return this.timesCitedService.shouldDisplayTimesCited && this.timesCitedService.isShowTimesCitedForSuprima();
        }else{
            return this.timesCitedService.shouldDisplayTimesCited;
        }
    }

    public shouldDisplayCitationTrial(){
            if(this.configurationUtil.isSuprima()){
               return this.isShowCitationTrialForSuprima();
            }else{
              return true;
            }
    }

}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsFullviewLink.service.ts